<template lang="pug">
  .kyrgyzstan
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/kyrgystan-min.png"
      )
      span {{ gettext('Киргизия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Это страна, в которой живет кочевой в прошлом народ – киргизы. Киргизия несмотря на свои скромные размеры может похвастаться необычайно красивыми горами, реками и озерами. Страна когда-то была одной из точек маршрута Великого шелкового пути, караваны которого имели возможность насладится её живописными маковыми и хлопковыми полями и превосходными фруктами. Здесь чувствуется дух настоящей Азии.') }}
        p {{ gettext('Киргизы очень общительный и отзывчивый народ. У них глубоко ценятся семейные традиции. Также они скромны, практичны, трудолюбивы и исполнительны.') }}
        p {{ gettext('Не все киргизы в своей родной стране могут найти высокооплачиваемую работу, поэтому многие из них едут в Россию, Южную Корею, Украину; страны Европы: Германию, Испанию, Чехию и другие в поисках достойного заработка и лучшей жизни. Из-за территориальной близости и отсутствия языкового барьера (многие киргизы знают русский язык) подавляющее большинство, почти 80 % киргизстанских работников, выбирают Россию для трудоустройства. Правда, лишь малая часть из них полностью довольны своим доходом, поскольку в России труд работников из Киргизии оценивается на порядок меньше, нежели самих россиян тех же профессий.') }}
        p {{ gettext('В основном, в России киргизы заняты в сферах предоставления услуг, торговли, строительства, гостиничного и ресторанного бизнеса, производства.') }}
        p {{ gettext('Киргизы, как и остальные мигранты, делают весомый вклад в рост экономики стран, в которых трудятся.') }}
        p {{ gettext('Эту нацию характеризируют как серьезных, добросовестных и старательных работников.') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/kyrgystan-min.png'})
  },
  name: 'Kyrgyzstan',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Kyrgyzstan | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/kyrgyzstan/index.vue